import React, { useContext } from "react";
import "./Intro.css";
import Vector1 from "../../img/Vector1.png";
import Vector3 from "../../img/Vector4.png";
import boy3 from "../../img/boy3.png";
import glassesimoji from "../../img/glassesimoji.png";
import thumbup from "../../img/thumbup.png";
import crown from "../../img/crown.png";
import FloatinDiv from "../FloatingDiv/FloatingDiv";
import Github from "../../img/github.png";
import LinkedIn from "../../img/linkedin.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import resume from './Resume.pdf';

const Intro = () => {
  // Transition
  const transition = { duration: 2, type: "spring" };

  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="Intro" id="Intro">
      {/* left name side */}
      <div className="i-left">
        <div className="i-name">
          {/* yahan change hy darkmode ka */}
          <span style={{ color: darkMode ? "white" : "" }}>Hey! I'm</span>
          <span>Mohammad Tasib</span>
          <span>
          I have professional experience with programming languages and tools such as React, Redux, HTML, CSS, Sass, Bootstrap, javascript, ES6, Express Js, Material UI, and Firebase Auth to contribute features by writing and maintaining code.
          </span>
        </div>
        <a href={resume} download>
          <button className="button i-button">DOWNLOAD RESUME</button>
        </a>
        {/* social icons */}
        <div className="i-icons">
          <a  href="https://github.com/MdTasib" target="_blank" rel="noreferrer">
          <img src={Github} alt="" />
          </a>
          <a  href="https://www.linkedin.com/in/mohammad-tasib-4341b71b4/" target="_blank" rel="noreferrer">
          <img src={LinkedIn} alt="" />
          </a>
        </div>
      </div>
      {/* right image side */}
      <div className="i-right">
        <img src={Vector1} alt="" />
        <img src={Vector3} alt="" height={600}/>
        <img src={boy3} alt="" width={250}/>
        {/* animation */}
        <motion.img
          initial={{ left: "-36%" }}
          whileInView={{ left: "-24%" }}
          transition={transition}
          src={glassesimoji}
          alt=""
        />

        <motion.div
          initial={{ top: "-4%", left: "74%" }}
          whileInView={{ left: "68%" }}
          transition={transition}
          className="floating-div"
        >
          <FloatinDiv img={crown} text1="Web" text2="Developer" />
        </motion.div>

        {/* animation */}
        <motion.div
          initial={{ left: "8rem", top: "20rem" }}
          whileInView={{ left: "6rem"}}
          transition={transition}
          className="floating-div"
        >
          {/* floatinDiv mein change hy dark mode ka */}
          <FloatinDiv img={thumbup} text1="Front End" text2="Award" />
        </motion.div>

        <div className="blur" style={{ background: "rgb(238 210 255)" }}></div>
        <div
          className="blur"
          style={{
            background: "#C1F5FF",
            top: "17rem",
            width: "21rem",
            height: "11rem",
            left: "-9rem",
          }}
        ></div>
      </div>
    </div>
  );
};

export default Intro;
